import { render, staticRenderFns } from "./ClusterTeachersPIP.vue?vue&type=template&id=71f6a4eb&scoped=true&"
import script from "./ClusterTeachersPIP.vue?vue&type=script&lang=js&"
export * from "./ClusterTeachersPIP.vue?vue&type=script&lang=js&"
import style0 from "./ClusterTeachersPIP.vue?vue&type=style&index=0&id=71f6a4eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f6a4eb",
  null
  
)

export default component.exports